const BALUSTER_SPACING = 4;

//Form elements
const formInputs = {
    railingFt: document.getElementById('railingLengthFeet'),
    railingIn: document.getElementById('railingLengthInches'),
    numOfPost: document.getElementById('numberOfPosts'),
    sizeOfPost: document.getElementById('postSize'),
    form: document.getElementById('baluster-calc')
}

//Images and cards
const inputImages = document.querySelectorAll('.calculator--image');
const balusterStyleCards = document.querySelectorAll('.baluster');
const cardsContainer = document.querySelector('#baluster-calc .products-scroll-inner');
const cardsContainerWrapper = document.querySelector('.products-flex-stretch');
const balusterResult = document.getElementById('baluster-result');

if (cardsContainer) cardsContainer.addEventListener('click', handleCardSelection);
if (formInputs.form) formInputs.form.addEventListener('submit', getBalustersNeeded);

// Clear input from negative and exponential inputs
document.querySelectorAll('.number-input').forEach((field) =>
    field.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '').replace(/^0+/, '') || '';
    })
);

//Display Image correspondig to form field
Object.values(formInputs).forEach((element, index) => {
    if (element) { 
        element.addEventListener('focus', () => {
            displayImage(index)
        });
    }
});

function handleCardSelection(event){
    const selectedCard = event.target.closest('product-card');

    if (selectedCard) {
        const allCards = document.querySelectorAll('product-card');
        allCards.forEach(card => card.classList.remove('selected'));
        selectedCard.classList.add('selected');
        cardsContainerWrapper.classList.toggle('error', false);

        const cardIndex = Array.from(allCards).indexOf(selectedCard) + 4;
        displayImage(cardIndex)
    }
}

function displayImage(imageIndex) {
    inputImages.forEach(image => {
        image.style.display = 'none';
    });

    imageIndex = (imageIndex === 0 || imageIndex === 1) ? 1 : imageIndex;
    inputImages[imageIndex].style.display = 'block';
}

function getCalculations() {

    const { railingFt, railingIn, numOfPost, sizeOfPost } = formInputs;

    const totalRailingLength = (parseFloat(railingFt.value) * 12) + (parseFloat(railingIn.value) || 0);
    const totalPostSpace = parseFloat(numOfPost.value) * parseFloat(sizeOfPost.value);

    const balusterStyle = document.querySelector('.product-card.selected .product-card-title .size');
    if (!balusterStyle) {
        document.querySelector('.products-flex-stretch').classList.add('error');
        return 0;
    }

    const styleWidth = balusterStyle.getAttribute('data-style-width');
    const balusterWidth = calculateBalusterWidth(styleWidth);
    const spaceForBalusters = totalRailingLength - totalPostSpace;
    const balusterUnitWidth = balusterWidth + BALUSTER_SPACING;

    return Math.ceil(spaceForBalusters / balusterUnitWidth);

}

function calculateBalusterWidth(styleWidth) {
    if (styleWidth.includes('/')) {
        const [numerator, denominator] = styleWidth.split('/').map(Number);
        return numerator / denominator;
    }
    return parseFloat(styleWidth);
}

function getBalustersNeeded(event) {
    event.preventDefault();
    const sucessCalc = getCalculations();

    if(!sucessCalc) return
    balusterResult.classList.add('active');
    balusterResult.textContent = `Total Balusters Needed: ${sucessCalc}`
}
